"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DayNightIcons = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledIcon = _styledComponents["default"].svg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\theight: 30px;\n\twidth: 30px;\n\t", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.mediaQueries.large, "{\n\theight : 60px;\n\twidth : 60px;\n}");
});
var SunIcon = function SunIcon() {
  return /*#__PURE__*/_react["default"].createElement(StyledIcon, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    "data-name": "Rectangle 2861",
    fill: "none",
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    "data-name": "Path 14617",
    d: "M28.111 15.788a12.323 12.323 0 1 0 12.323 12.323 12.328 12.328 0 0 0-12.323-12.323zM3.465 30.575h4.929a2.465 2.465 0 1 0 0-4.929H3.465a2.465 2.465 0 1 0 0 4.929zm44.363 0h4.929a2.465 2.465 0 0 0 0-4.929h-4.929a2.465 2.465 0 0 0 0 4.929zM25.646 3.465v4.929a2.465 2.465 0 1 0 4.929 0V3.465a2.465 2.465 0 1 0-4.929 0zm0 44.363v4.929a2.465 2.465 0 0 0 4.929 0v-4.929a2.465 2.465 0 0 0-4.929 0zM13.3 9.823A2.457 2.457 0 0 0 9.823 13.3l2.612 2.612a2.457 2.457 0 0 0 3.475-3.475zm30.486 30.488a2.457 2.457 0 0 0-3.475 3.475l2.612 2.614a2.457 2.457 0 0 0 3.477-3.477zM46.4 13.3a2.457 2.457 0 0 0-3.475-3.475l-2.612 2.612a2.457 2.457 0 0 0 3.475 3.475zM15.911 43.786a2.457 2.457 0 0 0-3.475-3.475l-2.613 2.612A2.457 2.457 0 0 0 13.3 46.4z",
    transform: "translate(1.89 1.89)",
    fill: "#FFF"
  }));
};
var MoonIcon = function MoonIcon() {
  return /*#__PURE__*/_react["default"].createElement(StyledIcon, {
    width: "63",
    height: "64",
    viewBox: "0 0 63 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M57.0453 44.9495L57.4442 44.5506C57.7788 44.1955 57.9895 43.7417 58.0448 43.2569C58.1001 42.7722 57.9971 42.2825 57.7511 41.8612C57.5052 41.4399 57.1294 41.1094 56.6801 40.9193C56.2308 40.7292 55.732 40.6896 55.2583 40.8064C50.8447 41.7868 46.2552 41.638 41.9144 40.3738C37.5736 39.1096 33.6219 36.7708 30.425 33.5739C27.2281 30.377 24.8893 26.4253 23.6251 22.0845C22.3609 17.7437 22.2121 13.1542 23.1925 8.74063C23.3101 8.27081 23.2736 7.77563 23.0883 7.32816C22.903 6.88068 22.5788 6.5046 22.1636 6.2554C21.7483 6.00619 21.2639 5.89706 20.7819 5.9441C20.2999 5.99114 19.8457 6.19186 19.4864 6.51665L19.2432 6.75988C16.704 9.2351 14.6798 12.1885 13.2874 15.4497C11.895 18.7109 11.162 22.2155 11.1305 25.7614C11.099 29.3073 11.7697 32.8244 13.104 36.1098C14.4382 39.3953 16.4096 42.3841 18.9045 44.904C21.3994 47.4239 24.3684 49.4251 27.6403 50.7921C30.9123 52.1591 34.4225 52.8649 37.9685 52.8688C41.5146 52.8727 45.0263 52.1747 48.3013 50.8149C51.5762 49.4552 54.5497 47.4606 57.0501 44.9462L57.0453 44.9495Z",
    fill: "white"
  }));
};
var DayNightIcons = {
  SunIcon: SunIcon,
  MoonIcon: MoonIcon
};
exports.DayNightIcons = DayNightIcons;